class FaqAccordion {

  accordionToggleClass = 'faq-item--active';

  constructor(toggles) {
    this.toggles = toggles;

    Array.forEach(this.toggles, (toggle) => {
      toggle.addEventListener('click', this.handleToggleClick);
    });
  }

  handleToggleClick = (e) => {
    e.currentTarget.classList.toggle(this.accordionToggleClass);
  }
}

const toggles = document.querySelectorAll('.js-roboyagi-faq');

if (toggles !== null && toggles.length > 0) {
  // eslint-disable-next-line
  new FaqAccordion(toggles);
}
